// extracted by mini-css-extract-plugin
export default {"mainWrapper":"instructions-and-charges_mainWrapper__z5Mvi","formActionWrapper":"instructions-and-charges_formActionWrapper__hykxo"};